<template>
    <div class="w-full border border-gray-200 rounded-xl shadow p-5">
        <div class="border-b border-gray-200 pb-5 flex justify-between">
            <span class="text-xl font-bold">
                {{ props.title }}
            </span>
            <hts-form-button
                color="main"
                icon-name="hi-adjustments-vertical-icon"
                icon-position="right">
                {{ $t('labels.startToDelivery') }}
            </hts-form-button>
        </div>
        <div class="flex w-full">
            <div class="w-3/4 h-full">
                <hts-map
                    :zoom="2"
                    map-style="height:100%" />
            </div>
            <div class="w-1/4 p-5">
                <span class="text-4xl font-bold">
                    {{ props.amount }}
                </span>
                <div
                    v-for="(item, index) in sampleData"
                    :key="index">
                    <rating
                        :icon="item.icon"
                        :title="item.title"
                        :width="item.width.toString()" />
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import Rating from './rating.vue'
const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  amount: {
    type: String,
    default: ''
  }
})
const sampleData = [
  {
    icon: '/assets/america-icon.png',
    title: 'United States',
    width: 50
  },
  {
    icon: '/assets/vietnam-icon.png',
    title: 'Việt Nam',
    width: 30
  },
  {
    icon: '/assets/united-kingdom-icon.png',
    title: 'United Kingdom',
    width: 20
  },
  {
    icon: '/assets/australia-icon.png',
    title: 'Australia',
    width: 10
  },
  {
    icon: '/assets/canada-icon.png',
    title: 'Canada',
    width: 10
  }
]
</script>
